export default __webpack_public_path__ + "static/media/3-reducao-risco.243f2dbf.svg";